"use strict";

import {zoomInMap} from "./ajax-form-map";

export function initInScope($scope) {
    $scope.find('.js-geo-location').on('click', function (evt) {
        evt.preventDefault();
        let $targetLat = $($(this).data('target-lat'));
        let $targetLng = $($(this).data('target-lng'));

        navigator.geolocation.getCurrentPosition(function(position) {

            $targetLat.val(position.coords.latitude);
            $targetLng.val(position.coords.longitude);

            $('.js-location-input').val('');
            zoomInMap(position.coords.latitude,position.coords.longitude);

            $targetLng.closest('form').trigger('submit');
        });
    });
}